import { Component, computed, forwardRef, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormsModule } from '@angular/forms';
import { AuthService } from '@modules/auth/services/auth.service';
import { IUser } from '@modules/clients/models/user';
import { DropdownModule } from 'primeng/dropdown';
import { GlobalStateService } from 'src/app/shared/services/global-state/global-state.service';

@Component({
  selector: 'app-drop-down-company',
  standalone: true,
  imports: [DropdownModule, FormsModule],
  templateUrl: './drop-down-company.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropDownCompanyComponent),
      multi: true,
    },
  ],
})
export class DropDownCompanyComponent implements ControlValueAccessor, AfterViewInit {
  public companiesList = computed(() => {
    const state = this.globalStateService.state$?.();
    const companies = state?.companies ?? [];
    return companies.map((company: any) => ({ id: company.id, nameCompany: `${company.nameCompany}` }));
  });

  public setSelectedCompanyId = computed(() => {
    const state = this.globalStateService.state$?.();
    return state?.selectedCompanyId ?? 0;
  });

  @Input() showFloatLabel: boolean = false;
  @Input() showSimpleLabel: boolean = false;
  @Input() showInput: boolean = true;
  @Input() hiddenLabel: boolean = false;
  @Output() selectionChange = new EventEmitter<any>();

  value: any = null;
  disabled = false;
  onChange = (_: any) => {};
  onTouched = () => {};

  constructor(public readonly authService: AuthService, private readonly globalStateService: GlobalStateService) {}
  ngAfterViewInit(): void {  
    if (this.setSelectedCompanyId() !== 0) {
      this.onSelect({value: this.setSelectedCompanyId()});
    }
  }


  public get user(): IUser {
    return this.authService.getUser();
  }

  // ControlValueAccessor methods
  writeValue(value: any): void {
    this.value = value;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onSelect(event: any) {
    if (!event) {
      this.value = null;
      this.onChange(null);
      this.onTouched();
      this.selectionChange.emit(null);
      return;
    }

    this.value = event.value;
    this.onChange(this.value);
    this.selectionChange.emit(this.value);
    this.onTouched();
  }
}
